import { Thread } from "@store/threads.store";
import { isToday, isWithinInterval, subDays } from "date-fns";

type GroupedThreads = {
  pinned: Thread[];
  today: Thread[];
  last7Days: Thread[];
  last30Days: Thread[];
};

const sortByDateDesc = (threads: Thread[]): Thread[] => {
  return threads.sort((a, b) => {
    const aDate = new Date(a.updatedAt ?? a.createdAt).getTime();
    const bDate = new Date(b.updatedAt ?? b.createdAt).getTime();
    return bDate - aDate;
  });
};

export const groupThreadsForDisplay = (threads: Thread[]): GroupedThreads => {
  const pinned: Thread[] = [];
  const today: Thread[] = [];
  const last7Days: Thread[] = [];
  const last30Days: Thread[] = [];

  const now = new Date();
  const sevenDaysAgo = subDays(now, 7);
  const thirtyDaysAgo = subDays(now, 30);

  threads.forEach((thread) => {
    if (thread.pinned) {
      pinned.push(thread);
      return;
    }

    const date = new Date(thread.updatedAt ?? thread.createdAt);

    if (isToday(date)) {
      today.push(thread);
    } else if (isWithinInterval(date, { start: sevenDaysAgo, end: now })) {
      last7Days.push(thread);
    } else if (isWithinInterval(date, { start: thirtyDaysAgo, end: now })) {
      last30Days.push(thread);
    }
  });

  return {
    pinned: sortByDateDesc(pinned),
    today: sortByDateDesc(today),
    last7Days: sortByDateDesc(last7Days),
    last30Days: sortByDateDesc(last30Days),
  };
};
